<div [ngClass]="{
  'err-pc-web': factorySer.isWebStyle && !mobileStye,
  'err-header': (factorySer.isWebStyle || factorySer.isMobileWebStyle) && factorySer.logined && !mobileStye}">
  <div class="error-body">
    <div class="err-box">
      <!-- 优先使用配置，兜底使用背景图 -->
      <img *ngIf="errImg || defaultImg" class="error-img" [src]="errImg || defaultImg" alt="error-img">
      <div *ngIf="!(errImg || defaultImg)" class="error-img"></div>
      <div class="err-title">{{errInfo?.title}}</div>
      <ng-container *ngIf="errInfo else ComDesc">
        <div class="err-msg" [innerHTML]="errInfo?.description"></div>
      </ng-container>
      <ng-template #ComDesc>
        <div class="err-msg">{{errMsg | acpText}}</div>
      </ng-template>
      <com-btn 
        (btnActionEmit)="btnAction()"
        [format]="false"
        [label]="timeout===0 ? btnTxt : (btnTxt+'（'+timeout+'）')"
        [disabled]="timeout !== 0"
        >
      </com-btn>
    </div>
  </div>
</div>

